import React, { useState } from 'react';

import Distance from '../../../../styled/Distance';
import { Column, Columns } from '../../../../styled/Columns/wrappers';
import { BoxIcon } from '../../../../styled/Icon';
import { Action, Caption, Head } from '../../../../styled/StockStatus/wrappers';
import VariantsInStockPanel from './VariantsInStockPanel';
import useContext from '../../../../hooks/useContext';
import { ProductContext } from '../providers/ProductProvider';

export default function VariantsInStock() {
  const [showPanel, setShowPanel] = useState(false);
  const { configurations, adjacentOptions, isActive, distributionType } =
    useContext(ProductContext);

  if (
    (!adjacentOptions?.length && !configurations?.length) ||
    !isActive ||
    distributionType === 'Drop Shipment'
  ) {
    return null;
  }

  return (
    <>
      <Distance size={['3', '4']} />
      <Columns className="space-2">
        <Column>
          <BoxIcon className="large bump-down" />
        </Column>
        <Column>
          <Head>Utföranden i butikslager</Head>
          <Caption>Utföranden av produkten som finns tillgängligt i butikslager</Caption>

          <Action onClick={() => setShowPanel(true)}>Se utföranden i butikslager</Action>
        </Column>
      </Columns>

      {showPanel && <VariantsInStockPanel onClose={() => setShowPanel(false)} />}
    </>
  );
}
